import { Component } from 'react';

import DataTypeEditor from 'common/components/DataTypeEditor/DataTypeEditor';
import styles from '../ValueSets.scss';

class FixedValue extends Component {
    _getClassName() {
        const { dataType } = this.props;
        switch (dataType && dataType.toLowerCase()) {
            case 'small_text':
                return styles.inputText;
            case 'integer':
                return styles.inputText;
            case 'dateonly':
                return styles.inputDate;
            case 'datetime':
                return styles.inputDate;
            default:
                return styles.inputDefault;
        }
    }

    render() {
        const {
            dataType,
            value
        } = this.props;

        return (
            <DataTypeEditor
                dataType={dataType}
                disabled={true}
                className={this._getClassName()}
                value={value} />
        );
    }
}

export default FixedValue;
